import { sanitizeAmount } from "../../TradeForm/utils/format";

export const KEYPAD_DELETE = "del";

export const KEYPAD_KEYS = [
  "1", "2", "3", "4", "5", "6", "7", "8", "9", ".", "0", KEYPAD_DELETE,
];

/**
 * Applies an on-screen keypad key to an amount draft.
 * In overtype mode the first digit replaces the whole draft, "." starts
 * a fresh "0." and delete removes the last character.
 * @param {string} draft
 * @param {string} key
 * @param {{ isOvertype?: boolean }} [options]
 * @returns {string}
 */
export const applyKeypadKey = (draft, key, { isOvertype = false } = {}) => {
  if (isOvertype) {
    if (key === KEYPAD_DELETE) return draft.slice(0, -1);
    return key === "." ? "0." : key;
  }

  if (key === KEYPAD_DELETE) return draft.slice(0, -1);

  if (key === ".") {
    return draft.includes(".") ? draft : `${draft || "0"}.`;
  }

  return draft === "0" ? key : sanitizeAmount(draft + key);
};
